import React, { useEffect, useState } from 'react';
import { useLoader } from '../../../../hooks';
import { EventsService } from '../../../../services/EventsService';
import { timeOnly } from '../../../../utils/dateHelper';
import { usToEuCurrencyFormat } from '../../../../utils/currencyHelper';
import EChart from '../../../../components/Echarts/Echarts';
import Typography from '../../../../components/Typography/Typography';
import TabsComponent from '../../../../components/Tabs/Tabs';
import classes from '../../../../styles/AllDevices.module.css';

const DataLogModal = ({ data, setOpen }) => {
    const [startLoader, stopLoader] = useLoader();
    const [graphData, setGraphData] = useState([]);
    const [consumptionData, setConsumptionData] = useState([]);
    const [socData, setSocData] = useState([]);
    const [selectedIndex] = useState(0);

    useEffect(() => {
        getDataLog();
    }, [data?.instanceId]);

    const getDataLog = () => {
        if (data?.instanceId) {
            let filteredParams = {
                instanceId: data?.instanceId,
                startTime: data.startTime,
                endTime: data.endTime !== '--' ? data.endTime : ''
            };
            EventsService.GetDataLog(filteredParams, startLoader, handleSuccess, handleError, stopLoader);
        }
    };

    const handleSuccess = ({ data }) => {
        setGraphData(data.data.powerData);
        setConsumptionData(data.data.consumptionData || [{ data: [] }]);
        setSocData(data.data.socData || [{ data: [] }]);
    };

    const handleError = (err) => {
        console.error(err);
    };

    let tabs = [
        {
            name: 'Power (kW)',
            component: (
                <div>
                    <EChart series={graphData} type="line" xFormatter={timeOnly} yFormatter={(v) => usToEuCurrencyFormat(parseFloat(v).toFixed(2))} yTooltipSuffix={['kW']} />
                </div>
            ),
        },
        {
            name: 'Consumption (kWh)',
            component: (
                <div>
                    <EChart
                        series={consumptionData}
                        type="line"
                        lineType={'area'}
                        xFormatter={timeOnly}
                        yFormatter={(v) => usToEuCurrencyFormat(parseFloat(v).toFixed(2))}
                        yTooltipSuffix={['kWh']}
                    />
                </div>
            ),
        },
        {
            name: 'SoC (%)',
            component: (
                <div>
                    <EChart series={socData} type="line" xFormatter={timeOnly} yFormatter={(v) => usToEuCurrencyFormat(parseFloat(v).toFixed(2))} yTooltipSuffix={['%']} />
                </div>
            ),
        },
    ];

    return (
        <div style={{ width: '50vw', maxHeight: '90vh' }}>
            <div className={classes.AllDevices}>
                <div className={classes.Header}>
                    <Typography content={`Data Log`} />
                </div>
            </div>

            <TabsComponent
                tabs={tabs}
                selectedIndex={selectedIndex}
            />
            <div className={classes.ButtonContainer}>
                <div className="btn-secondary" onClick={setOpen}>
                    Close
                </div>
            </div>
        </div>
    );
};

export default DataLogModal;